/* istanbul ignore file */

import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/**
 * Wizard workspace options service
 * Set the workspace options for the workflow import wizard step
 */
@Injectable()
export class WorkspaceService {
    /* istanbul ignore next*/
    workspaceForm: FormGroup = this.formBuilder.group({
        useExistingGroup: [true],
        selectedGroup: [''],
        newDatasetName: ['', Validators.required],
    });
    addingScans = false;
    addingStations = false;
    datasetNameHidden = false;

    /* istanbul ignore next*/
    constructor(private formBuilder: FormBuilder) {}

    /** Initializes the workspace form */
    setWorkspace(workspace: any): void {
        this.workspaceForm.reset();
        if (!workspace?.workspace) {
            console.error('Undefined workspace');
            return;
        }

        this.workspaceForm.controls['selectedGroup'].setValue(workspace.workspace);

        // Lacks code to select categories due to a bug
    }

    setAddingScans(addingScans: boolean): void {
        this.addingScans = addingScans;
    }

    setAddingStations(addingStations: boolean): void {
        this.addingStations = addingStations;
    }

    setDatasetNameHidden(flag: boolean): void {
        this.datasetNameHidden = flag;
    }
}
